import { j as o } from "./jsx-runtime-3tyXYecC.mjs";
import { F as a } from "./flex-Cc3osQLf.mjs";
import { B as c } from "./body-text-BiQwh5-U.mjs";
import { f } from "./index-LyFokDcn.mjs";
import { I as u } from "./icon-tile-BJ1ib0c2.mjs";
import { B as n } from "./base-headline-Dw8BrcrM.mjs";
import { createContext as d, useContext as x } from "react";
import { m as p } from "./tss-DN0acMKN.mjs";
import { A as g } from "./avatar-1JHdkfls.mjs";
const l = d({ size: "medium" });
function j(e) {
  const { size: r } = x(l);
  let t = 48;
  return r === "small" ? t = 40 : r === "large" && (t = 56), /* @__PURE__ */ o.jsx(g, { ...e, size: t });
}
const h = p()(({ constructs: e, typography: r }) => ({
  titleSmall: {
    color: e.text.neutral.xStrong,
    fontWeight: r.fontWeightSemibold
  }
}));
function v(e, r, t) {
  return r === "large" ? /* @__PURE__ */ o.jsx(n, { color: "neutral-strong", component: "div", size: "small", children: e }) : r === "small" ? /* @__PURE__ */ o.jsx("div", { className: t.titleSmall, children: e }) : (
    // default is medium
    /* @__PURE__ */ o.jsx(n, { color: "neutral-strong", component: "div", size: "extra-small", children: e })
  );
}
function B({ icon: e, subtitle: r, size: t = "medium", title: s }) {
  const { classes: i } = h(), m = {
    large: 56,
    medium: 48,
    small: 44
  };
  return f.ifFeature(
    "encore",
    /* @__PURE__ */ o.jsx(l.Provider, { value: { size: t }, children: /* @__PURE__ */ o.jsxs(a, { "data-fabric-component": "BadgeV2", gap: 2, children: [
      e && typeof e == "string" ? /* @__PURE__ */ o.jsx(u, { icon: e, size: m[t] }) : e,
      /* @__PURE__ */ o.jsxs(a, { flexDirection: "column", justifyContent: "center", children: [
        v(s, t, i),
        r && /* @__PURE__ */ o.jsx(c, { color: "neutral-weak", size: t, weight: "regular", children: r })
      ] })
    ] }) }),
    // render nothing for Jade
    null
  );
}
B.Avatar = j;
export {
  B
};
//# sourceMappingURL=badge-v2-GpmLELaL.mjs.map
